/*eslint-disable*/
const state ={
  element: {},
  data:[],
  trashedData:[],
  sectionName:'',
  sectionNameCategory:'',
}
export default state
